import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CounterViewModel from "../viewmodels/CounterViewModel";
import PhotoGallery from "./PhotoGallery";

// The gallery is every published artefact in descending order (newest first).
// Image 0 is gated (never shown), so the keys are counter..1. The shared
// PhotoGallery handles paging, the lightbox, the spinner and the quotes.
const GalleryView = () => {
  const { page } = useParams();
  const parsedPage = parseInt(page, 10);
  const currentPage = Number.isInteger(parsedPage) && parsedPage >= 1 ? parsedPage : 1;

  const [imageKeys, setImageKeys] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setImageKeys(null);
    (async () => {
      try {
        const counter = await CounterViewModel.getCounter();
        if (cancelled) return;
        const count = Number.isFinite(counter) ? Math.max(0, Math.floor(counter)) : 0;
        const keys = [];
        for (let k = count; k >= 1; k--) keys.push(k);
        setImageKeys(keys);
      } catch (error) {
        console.error("Error loading gallery:", error);
        if (!cancelled) setImageKeys([]);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return <PhotoGallery imageKeys={imageKeys} currentPage={currentPage} basePath="/gallery" />;
};

export default GalleryView;
